import { TicketType } from '../../components/ticket/ticket.constants';

export const UserRoles = {
  Guest: 'GUEST',
  BackOffice: 'BACK_OFFICE',
  BackOfficeDirect: 'BACK_OFFICE_DIRECT',
  FrontOffice: 'FRONT_OFFICE',
  FrontOfficeWithComplete: 'FRONT_OFFICE_WITH_COMPLETE',
  FrontOfficeWithStandingOrders: 'FRONT_OFFICE_WITH_STANDING_ORDERS',
  PadContactSearch: 'PAD_CONTACT_SEARCH',
  Admin: 'ADMIN',
  PasswordReset: 'PASSWORD_RESET',
  DataCapturingProvider: 'DATA_CAPTURING_PROVIDER',
  Revision: 'REVISION',
  Compliance: 'COMPLIANCE',
  SantanderEmployeeBranch: 'SANTANDER_EMPLOYEE_BRANCH',
};

export const UserPermissions = {
  [TicketType.Receiving]: {
    Create: 'INCOMING_AID_REQUEST_CREATE',
    Read: 'INCOMING_AID_REQUEST_READ',
    Handle: 'INCOMING_AID_REQUEST_HANDLE',
    AllBranches: 'INCOMING_AID_REQUEST_ALL_BRANCHES',
    CaptureTransactions: 'INCOMING_CAPTURE_TRANSACTIONS',
  },
  [TicketType.Transferring]: {
    Create: 'OUTGOING_AID_REQUEST_CREATE',
    Read: 'OUTGOING_AID_REQUEST_READ',
    Handle: 'OUTGOING_AID_REQUEST_HANDLE',
    Complete: 'OUTGOING_AID_REQUEST_COMPLETE',
    AllBranches: 'OUTGOING_AID_REQUEST_ALL_BRANCHES',
  },
  Admin: {
    administerUsers: 'ADMINISTER_USERS',
    resetPassword: 'RESET_PASSWORD',
  },
  Inbox: {
    newAndDoneDocuments: 'INBOX_FOR_NEW_AND_DONE_DOCUMENTS',
    rejectedDocumentsWithoutIban: 'INBOX_FOR_REJECTED_DOUCMENTS_WIHTOUT_IBAN',
  },
};

export const chooseTemplate = (templates) => {
  return (userService) => {
    'ngInject';

    const role = userService.getRole();
    if (role) {
      return templates[role.toLowerCase()] || templates.defaultTemplate;
    }
    return templates.defaultTemplate;
  };
};
